// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _default;
    }
});
var _react = /*#__PURE__*/ _interop_require_wildcard(require("react"));
var _SplitCellsOutlined = /*#__PURE__*/ _interop_require_default(require("@ant-design/icons-svg/lib/asn/SplitCellsOutlined"));
var _AntdIcon = /*#__PURE__*/ _interop_require_default(require("../components/AntdIcon"));
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interop_require_wildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
        return obj;
    }
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
        return {
            default: obj
        };
    }
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) {
        return cache.get(obj);
    }
    var newObj = {
        __proto__: null
    };
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj){
        if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
            var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
            if (desc && (desc.get || desc.set)) {
                Object.defineProperty(newObj, key, desc);
            } else {
                newObj[key] = obj[key];
            }
        }
    }
    newObj.default = obj;
    if (cache) {
        cache.set(obj, newObj);
    }
    return newObj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var SplitCellsOutlined = function(props, ref) {
    return /*#__PURE__*/ _react.createElement(_AntdIcon.default, _object_spread_props(_object_spread({}, props), {
        ref: ref,
        icon: _SplitCellsOutlined.default
    }));
};
/**![split-cells](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PHN0eWxlIC8+PC9kZWZzPjxwYXRoIGQ9Ik05MzguMiA1MDguNEw3ODcuMyAzODljLTMtMi40LTcuMy0uMi03LjMgMy42VjQ3OEg2MzZWMTg0aDIwNHYxMjhjMCAyLjIgMS44IDQgNCA0aDYwYzIuMiAwIDQtMS44IDQtNFYxNDRjMC0xNS41LTEyLjUtMjgtMjgtMjhINTk2Yy0xNS41IDAtMjggMTIuNS0yOCAyOHY3MzZjMCAxNS41IDEyLjUgMjggMjggMjhoMjg0YzE1LjUgMCAyOC0xMi41IDI4LTI4VjcxMmMwLTIuMi0xLjgtNC00LTRoLTYwYy0yLjIgMC00IDEuOC00IDR2MTI4SDYzNlY1NDZoMTQ0djg1LjRjMCAzLjggNC40IDYgNy4zIDMuNmwxNTAuOS0xMTkuNGE0LjUgNC41IDAgMDAwLTcuMnpNNDI4IDExNkgxNDRjLTE1LjUgMC0yOCAxMi41LTI4IDI4djE2OGMwIDIuMiAxLjggNCA0IDRoNjBjMi4yIDAgNC0xLjggNC00VjE4NGgyMDR2Mjk0SDI0NHYtODUuNGMwLTMuOC00LjMtNi03LjMtMy42bC0xNTEgMTE5LjRhNC41MiA0LjUyIDAgMDAwIDcuMWwxNTEgMTE5LjVjMi45IDIuMyA3LjMuMiA3LjMtMy42VjU0NmgxNDR2Mjk0SDE4NFY3MTJjMC0yLjItMS44LTQtNC00aC02MGMtMi4yIDAtNCAxLjgtNCA0djE2OGMwIDE1LjUgMTIuNSAyOCAyOCAyOGgyODRjMTUuNSAwIDI4LTEyLjUgMjgtMjhWMTQ0YzAtMTUuNS0xMi41LTI4LTI4LTI4eiIgLz48L3N2Zz4=) */ var RefIcon = /*#__PURE__*/ _react.forwardRef(SplitCellsOutlined);
if (process.env.NODE_ENV !== 'production') {
    RefIcon.displayName = 'SplitCellsOutlined';
}
var _default = RefIcon;
